import type { KatalogEndpunkt } from '../gql/graphql.ts';
import { Endpunkt } from './Endpunkt.tsx';
import { Accordion } from '@e2n/ui';

type EndpunktListeProps = {
  endpunkte: KatalogEndpunkt[];
  gewaehlteEndpunkte: Record<string, string[]>;
  onEndpunktToggle: (enpunkt: KatalogEndpunkt) => void;
  onAttributToggle: (endpunktName: string, attributName: string) => void;
};

export function EndpunktListe({
  endpunkte,
  gewaehlteEndpunkte,
  onEndpunktToggle,
  onAttributToggle,
}: EndpunktListeProps) {
  return (
    <Accordion type="multiple" className="mt-6 gap-3">
      {endpunkte.map((endpunkt) => (
        <Endpunkt
          key={endpunkt.name}
          endpunkt={endpunkt}
          gewaehlteAttribute={gewaehlteEndpunkte[endpunkt.name]}
          onToggle={() => onEndpunktToggle(endpunkt)}
          onAttributToggle={(attributName) =>
            onAttributToggle(endpunkt.name, attributName)
          }
        />
      ))}
    </Accordion>
  );
}
